module.exports = __webpack_public_path__ + "static/media/facebook.0a27bbff.svg";